import React from "react";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import Button from '@/components/Button';
import rem from '@/utils/rem.js'
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconDelete } from '@/assets/svgs/delete.svg';
import { ReactComponent as IconWarningErrorCircle } from '@/assets/svgs/icon-warning-error.svg';

export const DeleteSourceSystemModal = ({
    visible,
    hide,
    handleSubmit,
}) => {

    return (
        <Modal visible={visible} variant="medium" close={hide}>
            <CardConfigure >
                <CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDelete />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Delete Source System
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
                <CardConfigure.Body>
                    <CardConfigure.Body.Col>
                        <div className="default-source-system">
                            <div className="default-source-system__message">
                                <span>Are you sure to delete Source System?</span>
                                <span>This action cannot be undone.</span>
                            </div>
                            <div className="default-source-system__alert">
                                <IconWarningErrorCircle />
                                <div className="default-source-system__alert__message--delete">
                                    Deleting the configuration will impact the data being <br />shared/received from/to the source system
                                </div>
                            </div>
                        </div>
                    </CardConfigure.Body.Col>
                </CardConfigure.Body>
                <CardConfigure.Footer>
                    <CardConfigure.Footer.Left>
                        <Button
                            customeHover
                            btnText
                            id="delete-ss-modal-cancel-btn"
                            text="Cancel"
                            submit={() => hide()}
                        />
                    </CardConfigure.Footer.Left>
                    <CardConfigure.Footer.Right>
                        <Button text="Delete"
                            warning
                            round
                            id="delete-ss-modal-confirm-btn"
                            data-testid="delete-ss-modal-confirm-btn"
                            submit={() => {
                                handleSubmit();
                            }} />
                    </CardConfigure.Footer.Right>
                </CardConfigure.Footer>
            </CardConfigure>
        </Modal>
    )
};
